import React from 'react';
import { Row, Col, Form } from 'reactstrap';
import FormInput from '../../common/FormInput';
import { safeNumberToString } from '../../../utils/productDataMappers';
import { useFormSection } from 'features/products/context/ProductDetailContext';

const StockControl: React.FC = () => {
  const { watch, setValue, getError } = useFormSection('stockControl');

  return (
    <fieldset className="border rounded p-2">
      <legend className="float-none w-auto px-2 mb-0 text-body" style={{ fontSize: '0.9rem' }}>Stock Control</legend>
      <Form>
        <Row>
          <Col md={4}>
            <FormInput
              id="available"
              label="Available"
              value={safeNumberToString(watch('available'))}
              onChange={(value: string) => setValue('available', value)}
              type="number"
            />
            {/* Display validation error if any */}
            {getError('available') && (
              <div className="text-danger small mt-1">
                {getError('available')?.message}
              </div>
            )}
          </Col>
          <Col md={4}>
            <FormInput
              id="inWH"
              label="In WH"
              value={safeNumberToString(watch('inWh'))}
              onChange={(value: string) => setValue('inWh', value)}
              type="number"
            />
            {/* Display validation error if any */}
            {getError('inWh') && (
              <div className="text-danger small mt-1">
                {getError('inWh')?.message}
              </div>
            )}
          </Col>
          <Col md={4}>
            <FormInput
              id="allocated"
              label="Allocated"
              value={safeNumberToString(watch('allocated'))}
              onChange={(value: string) => setValue('allocated', value)}
              type="number"
            />
            {/* Display validation error if any */}
            {getError('allocated') && (
              <div className="text-danger small mt-1">
                {getError('allocated')?.message}
              </div>
            )}
          </Col>
          <Col md={4}>
            <FormInput
              id="pending"
              label="Pending"
              value={safeNumberToString(watch('pending'))}
              onChange={(value: string) => setValue('pending', value)}
              type="number"
            />
            {/* Display validation error if any */}
            {getError('pending') && (
              <div className="text-danger small mt-1">
                {getError('pending')?.message}
              </div>
            )}
          </Col>
          <Col md={4}>
            <FormInput
              id="backOrder"
              label="Back Order"
              value={safeNumberToString(watch('backOrder'))}
              onChange={(value: string) => setValue('backOrder', value)}
              type="number"
            />
            {/* Display validation error if any */}
            {getError('backOrder') && (
              <div className="text-danger small mt-1">
                {getError('backOrder')?.message}
              </div>
            )}
          </Col>
          <Col md={4}>
            <FormInput
              id="onOrder"
              label="On Order"
              value={safeNumberToString(watch('onOrder'))}
              onChange={(value: string) => setValue('onOrder', value)}
              type="number"
            />
            {/* Display validation error if any */}
            {getError('onOrder') && (
              <div className="text-danger small mt-1">
                {getError('onOrder')?.message}
              </div>
            )}
          </Col>
        </Row>
      </Form>
    </fieldset>
  );
};

export default StockControl;
